module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/icons/material/MaterialIcons-Regular.ttf
// module id = ../../../../../src/assets/icons/material/MaterialIcons-Regular.ttf
// module chunks = styles